export const translations = {
	'Setup': {
		no: 'Oppsett',
	},
	'Authorization server (URL)': {
		no: 'Autorisasjonsserver (URL)',
	},
	'Client identifier': {
		no: 'Klientidentifikator',
	},
	'Client ID': {
		no: 'Klient-ID',
	},
	'Client secret': {
		no: 'Klienthemmelighet',
	},
	'e.g. read write': {
		no: 'f.eks. read write',
	},
	'Space-separated list of requested scopes': {
		no: 'Mellomromsseparert liste over forespurte scopes',
	},
	'Owner credentials': {
		no: 'Eierlegitimasjon',
	},
	'URL should start with http:// or https://': {
		no: 'URL må starte med http:// eller https://',
	},
};
